/* eslint-disable react/no-danger */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { ComponentProps, FC, useEffect, useRef, useState } from 'react';

import customColors from '../../utils/customColors';

interface LazySvgProps extends ComponentProps<'svg'> {
 name: string;
 styles?: { [key: string]: any };
}

// This hook can be used to create your own wrapper component.
const useLazySvgImport = (name: string) => {
 const importRef = useRef<FC<ComponentProps<'svg'>> | null>(null);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState<Error>();

 const importIcon = async () => {
  try {
   const waiter = await import(`@assets/icons/${name}.svg?raw`);
   if (!waiter.default) {
    importIcon();
    return;
   }
   importRef.current = waiter.default;

   //    console.log(name, waiter);
  } catch (err) {
   console.log(err);
   setError(err as Error);
  } finally {
   setLoading(false);
  }
 };

 useEffect(() => {
  setLoading(true);
  //   if (name) {
  importIcon();
  //   }
  //   return () => {
  //    importRef.current = undefined;
  //   };
 }, [name, importRef]);

 return {
  error,
  loading,
  Svg: importRef.current,
  importIcon,
 };
};

// Example wrapper component using the hook.
const LazySvg = ({ name, styles, ...props }: LazySvgProps) => {
 const { loading, error, Svg, importIcon } = useLazySvgImport(name);

 useEffect(() => {
  if (!Svg) {
   importIcon();
  }
 }, [Svg]);

 if (error) {
  return (
   <Box
    sx={{
     width: 18,
     height: 18,
     borderRadius: '4px',
     background: customColors.lightGray,
    }}
   />
  );
 }

 if (loading) {
  return (
   <Box
    sx={{
     width: 18,
     height: 18,
    }}
   />
  );
 }
 return (
  <Box sx={{ ...styles, display: 'flex' }}>
   {Svg && (
    <div
     //  {...props}
     style={{ width: '100%', display: 'flex' }}
     dangerouslySetInnerHTML={{ __html: Svg }}
    />
   )}
  </Box>
 );
};

export default LazySvg;
